<template>
  <div>
    <v-dialog v-model="value" persistent max-width="500" >
      <v-form @submit.prevent="saveSetting()" ref="formSetting" :lazy-validation="true" :disabled="isLoading">
        <v-card>
          <v-card-title class="primary white--text d-flex justify-space-between">{{ $t('customer.notification_setting') }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-5">
            <div class="d-flex justify-space-between">
              <div class="pt-2 text-center" style="width: 220px;">{{ $t('contract.contract_expired_soon') }}</div>
              <div style="width: 130px;">
                <v-currency-field v-model="formSetting.contractExpiredThresholdDays" dense outlined :min="1"
                  :max="365" :rules="[rules.required, rules.requiredNumber]" :disabled="isLoading" :isDisabledDecimal="true" />
              </div>
              <div class="pt-2 text-center" style="width: 60px;">{{ $t('day') }}</div>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-btn color="error" elevation="0" @click="dismiss()" :disabled="isLoading">
              <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
            </v-btn>
            <v-btn type="submit" color="success" elevation="0" :loading="isLoading" :disabled="isLoading">
              <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      isLoading: false,
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
        requiredNumber: value => value != 0 || this.$t('validate.please_input_data')
      },
      formSetting: {
        contractExpiredThresholdDays: null
      }
    };
  },
  props: {
    value: Boolean,
    marketId: String,
  },
  watch: {
    value(val) {
      if (val) {
        this.initData()
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions({
      getMarket: "markets/getMarket",
      updateMarketSetting: "marketSetting/updateMarketSetting",
      createMarketSetting: "marketSetting/createMarketSetting",
    }),
    async initData() {
      this.isLoading = true
      try {
        this.market = await this.getMarket({ marketId: this.marketId, force: true })
        if (this.market?.setting) {
          this.formSetting = this.market.setting
          if (!this.formSetting.contractExpiredThresholdDays) this.formSetting.contractExpiredThresholdDays = 90
        } else {
          this.formSetting.contractExpiredThresholdDays = 90
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.$toast.show({
          content: this.$t('validate.error_save_setting'),
          color: "error"
        })
      }
    },
    async saveSetting() {
      if (this.$refs.formSetting.validate()) {
        this.isLoading = true
        try {
          if (this.market) {
            this.formSetting = await this.updateMarketSetting({
              marketId: this.marketId,
              id: this.formSetting.objectId ? this.formSetting.objectId : null,
              contractExpiredThresholdDays: parseInt(this.formSetting.contractExpiredThresholdDays),
            })
          }
          this.isLoading = false
          this.$toast.show({
            content: this.$t('save_setting_success'),
            color: "success"
          })
          this.dismiss()
        } catch (error) {
          this.isLoading = false
          this.$toast.show({
            content: this.$t('validate.error_save_setting'),
            color: "error"
          })
          this.dismiss()
        }
      }
    },
    dismiss() {
      this.$emit("onSuccess", true)
      this.$emit("input", false);
    }
  },
};
</script>

<style lang="scss" scoped></style>
